module.exports = __webpack_public_path__ + "img/tecnicos.173d1834.png";